export const ROLE_PERMISSION = new Map();
ROLE_PERMISSION.set('C', 'Thêm');
ROLE_PERMISSION.set('R', 'Xem');
ROLE_PERMISSION.set('U', 'Sửa');
ROLE_PERMISSION.set('D', 'Xóa');
ROLE_PERMISSION.set('F', 'Toàn quyền sử dụng');
ROLE_PERMISSION.set('RBD', 'Xem ngày cụ thể');
ROLE_PERMISSION.set('RC', 'Xem và so sánh');
ROLE_PERMISSION.set('ACE', 'Administrator');

/**
 * Checks whether the currently logged-in user is a Store Owner or System Admin.
 * Store Owners (user.id === user.idParent) or Admins always bypass permission restrictions.
 */
export const isOwnerOrAdminUser = () => {
    try {
        const userStr = localStorage.getItem("user");
        if (!userStr) return false;
        const user = JSON.parse(userStr);
        if (!user) return false;

        if (user.admin === true || user.username === "vmass") return true;

        const userId = Number(user.id || user._id);
        const parentId = Number(user.idParent);
        if (userId && parentId && userId === parentId) return true;

        return false;
    } catch (e) {
        return false;
    }
};

/**
 * Safely parse role settings from localStorage.
 */
const getRoleSettings = () => {
    try {
        const raw = localStorage.getItem("roleSettings");
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : null;
    } catch (e) {
        return null;
    }
};

export const isRorF = (role) => {
    if (isOwnerOrAdminUser()) return true;

    const roleSettings = getRoleSettings();
    if (!roleSettings) return false;

    return roleSettings.some(
        (_role) => _role.role_alias === role && (_role.permission === "R" || _role.permission === "F")
    );
};

export const isRorRBD = (role) => {
    if (isOwnerOrAdminUser()) return true;

    const roleSettings = getRoleSettings();
    if (!roleSettings) return false;

    return roleSettings.some(
        (_role) => _role.role_alias === role && (_role.permission === "R" || _role.permission === "RBD" || _role.permission === "F")
    );
};

export const isRorRBDorRC = (role) => {
    if (isOwnerOrAdminUser()) return true;

    const roleSettings = getRoleSettings();
    if (!roleSettings) return false;

    return roleSettings.some(
        (_role) =>
            _role.role_alias === role &&
            (_role.permission === "R" || _role.permission === "RBD" || _role.permission === "RC" || _role.permission === "F")
    );
};

export const isC = (role) => {
    if (isOwnerOrAdminUser()) return true;

    const roleSettings = getRoleSettings();
    if (!roleSettings) return false;

    return roleSettings.some(
        (_role) => _role.role_alias === role && (_role.permission === "C" || _role.permission === "F")
    );
};

export const isR = (role) => {
    if (isOwnerOrAdminUser()) return true;

    const roleSettings = getRoleSettings();
    if (!roleSettings) return false;

    return roleSettings.some(
        (_role) => _role.role_alias === role && (_role.permission === "R" || _role.permission === "F")
    );
};

export const isU = (role) => {
    if (isOwnerOrAdminUser()) return true;

    const roleSettings = getRoleSettings();
    if (!roleSettings) return false;

    return roleSettings.some(
        (_role) => _role.role_alias === role && (_role.permission === "U" || _role.permission === "F")
    );
};

export const isD = (role) => {
    if (isOwnerOrAdminUser()) return true;

    const roleSettings = getRoleSettings();
    if (!roleSettings) return false;

    return roleSettings.some(
        (_role) => _role.role_alias === role && (_role.permission === "D" || _role.permission === "F")
    );
};

export const isF = (role) => {
    if (isOwnerOrAdminUser()) return true;

    const roleSettings = getRoleSettings();
    if (!roleSettings) return false;

    return roleSettings.some(
        (_role) => _role.role_alias === role && _role.permission === "F"
    );
};

export const isAnalyticsRC = () => {
    if (isOwnerOrAdminUser()) return true;

    const roleSettings = getRoleSettings();
    if (!roleSettings) return false;

    const targetAliases = [
        "analytics_debt",
        "analytics_income",
        "analytics_make_product",
        "analytics_order_payment",
        "analytics_outcome",
        "analytics_stock_logs",
        "analytics_table"
    ];

    return roleSettings.some(
        (_role) =>
            targetAliases.includes(_role.role_alias) &&
            (_role.permission === "RC" || _role.permission === "F")
    );
};

export const isAnalyticsRBD = () => {
    if (isOwnerOrAdminUser()) return true;

    const roleSettings = getRoleSettings();
    if (!roleSettings) return false;

    const targetAliases = [
        "analytics_debt",
        "analytics_income",
        "analytics_make_product",
        "analytics_order_payment",
        "analytics_outcome",
        "analytics_stock_logs",
        "analytics_table"
    ];

    return roleSettings.some(
        (_role) =>
            targetAliases.includes(_role.role_alias) &&
            (_role.permission === "RBD" || _role.permission === "F")
    );
};